// extracted by mini-css-extract-plugin
module.exports = {"network":"network___2Yi8O","link":"link___97ITC","icon":"icon___Q2rA2"};